import { Component } from '@angular/core';
import {
  NgbDropdown,
  NgbDropdownToggle,
  NgbDropdownMenu,
  NgbDropdownButtonItem,
  NgbDropdownItem,
  NgbDropdownAnchor,
} from '@ng-bootstrap/ng-bootstrap';
import { FormlyModule } from '@ngx-formly/core';

import { FormlyFieldBaseComponent } from '../formly-field-base.component';

@Component({
  selector: 'app-formly-button',
  templateUrl: './formly-button.component.html',
  styleUrl: './formly-button.component.scss',
  imports: [
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownMenu,
    NgbDropdownButtonItem,
    NgbDropdownItem,
    NgbDropdownAnchor,
    FormlyModule,
  ],
})
export class FormlyButtonComponent extends FormlyFieldBaseComponent {
  defaultOptions = {
    props: { type: 'button', btnClass: 'primary' },
  };

  onClick(event: any) {
    if (this.props.onClick) {
      this.props.onClick(event);
    }
  }
}
